import { render, staticRenderFns } from "./ListAddendum.vue?vue&type=template&id=46700b5a&"
import script from "./ListAddendum.vue?vue&type=script&lang=js&"
export * from "./ListAddendum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports